"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WithScreenQueriesType = void 0;
require("core-js/modules/es6.array.find.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _themeMapper = require("@gravity/theme-mapper");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _withWindowSize = _interopRequireDefault(require("./withWindowSize"));
var _excluded = ["windowSize"];
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withScreenQueries.js",
  _this = void 0;
function cov_2r3fhnpjvg() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withScreenQueries.js";
  var hash = "aa688207defdced05c6816bdd1207e1abb0faf92";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withScreenQueries.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 28
        },
        end: {
          line: 6,
          column: 91
        }
      },
      "1": {
        start: {
          line: 6,
          column: 85
        },
        end: {
          line: 6,
          column: 90
        }
      },
      "2": {
        start: {
          line: 14,
          column: 31
        },
        end: {
          line: 20,
          column: 2
        }
      },
      "3": {
        start: {
          line: 14,
          column: 65
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "4": {
        start: {
          line: 28,
          column: 26
        },
        end: {
          line: 39,
          column: 4
        }
      },
      "5": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 39,
          column: 4
        }
      },
      "6": {
        start: {
          line: 30,
          column: 32
        },
        end: {
          line: 30,
          column: 79
        }
      },
      "7": {
        start: {
          line: 31,
          column: 27
        },
        end: {
          line: 31,
          column: 95
        }
      },
      "8": {
        start: {
          line: 31,
          column: 86
        },
        end: {
          line: 31,
          column: 94
        }
      },
      "9": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "10": {
        start: {
          line: 41,
          column: 37
        },
        end: {
          line: 47,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 75
          },
          end: {
            line: 6,
            column: 76
          }
        },
        loc: {
          start: {
            line: 6,
            column: 85
          },
          end: {
            line: 6,
            column: 90
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 31
          },
          end: {
            line: 14,
            column: 32
          }
        },
        loc: {
          start: {
            line: 14,
            column: 65
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 28,
            column: 27
          }
        },
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 39,
            column: 4
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 29,
            column: 17
          },
          end: {
            line: 29,
            column: 18
          }
        },
        loc: {
          start: {
            line: 29,
            column: 47
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 29
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 31,
            column: 68
          },
          end: {
            line: 31,
            column: 69
          }
        },
        loc: {
          start: {
            line: 31,
            column: 86
          },
          end: {
            line: 31,
            column: 94
          }
        },
        line: 31
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 16,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 16,
            column: 17
          }
        }, {
          start: {
            line: 16,
            column: 21
          },
          end: {
            line: 16,
            column: 31
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 17,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 17,
            column: 17
          }
        }, {
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 31
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 18,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 18,
            column: 17
          }
        }, {
          start: {
            line: 18,
            column: 21
          },
          end: {
            line: 18,
            column: 31
          }
        }],
        line: 18
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 46
          },
          end: {
            line: 28,
            column: 79
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 60
          },
          end: {
            line: 28,
            column: 79
          }
        }],
        line: 28
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aa688207defdced05c6816bdd1207e1abb0faf92"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2r3fhnpjvg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2r3fhnpjvg();
var DEFAULT_BREAKPOINTS = (cov_2r3fhnpjvg().s[0]++, (0, _values.default)(_themeMapper.evolutionTheme.breakpoints).sort(function (a, b) {
  cov_2r3fhnpjvg().f[0]++;
  cov_2r3fhnpjvg().s[1]++;
  return a - b;
}));

/**
 * Determine which breakpoints are active based on the window size and array of breakpoints.
 * @param {Object} screenSize - Destructured object containing the window width.
 * @param {number[]} breakpoints - Array of breakpoint sizes.
 * @returns {Object} Object indicating active breakpoints.
 */
cov_2r3fhnpjvg().s[2]++;
var getActiveScreenQueries = function getActiveScreenQueries(_ref, _ref2) {
  var width = _ref.width;
  var _ref3 = (0, _slicedToArray2.default)(_ref2, 4),
    sm = _ref3[0],
    md = _ref3[1],
    lg = _ref3[2],
    xl = _ref3[3];
  cov_2r3fhnpjvg().f[1]++;
  cov_2r3fhnpjvg().s[3]++;
  return {
    xs: width < sm,
    sm: (cov_2r3fhnpjvg().b[0][0]++, width >= sm) && (cov_2r3fhnpjvg().b[0][1]++, width < md),
    md: (cov_2r3fhnpjvg().b[1][0]++, width >= md) && (cov_2r3fhnpjvg().b[1][1]++, width < lg),
    lg: (cov_2r3fhnpjvg().b[2][0]++, width >= lg) && (cov_2r3fhnpjvg().b[2][1]++, width < xl),
    xl: width >= xl
  };
};

/**
 * Enhances a component with screen query information based on window size and breakpoints.
 * @param {React.Component} EnhancedComponent - The component to enhance.
 * @param {number[]} breakpoints - Array of breakpoint sizes.
 * @returns {React.Component} Enhanced component with screen query information.
 */
cov_2r3fhnpjvg().s[4]++;
var withScreenQueries = function withScreenQueries(EnhancedComponent) {
  var breakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2r3fhnpjvg().b[3][0]++, DEFAULT_BREAKPOINTS);
  cov_2r3fhnpjvg().f[2]++;
  cov_2r3fhnpjvg().s[5]++;
  return (0, _withWindowSize.default)(function (_ref4) {
    var windowSize = _ref4.windowSize,
      props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
    cov_2r3fhnpjvg().f[3]++;
    var activeScreenQueries = (cov_2r3fhnpjvg().s[6]++, getActiveScreenQueries(windowSize, breakpoints));
    var _ref5 = (cov_2r3fhnpjvg().s[7]++, (0, _entries.default)(activeScreenQueries).find(function (_ref7) {
        var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
          isActive = _ref8[1];
        cov_2r3fhnpjvg().f[4]++;
        cov_2r3fhnpjvg().s[8]++;
        return isActive;
      })),
      _ref6 = (0, _slicedToArray2.default)(_ref5, 1),
      activeScreen = _ref6[0];
    cov_2r3fhnpjvg().s[9]++;
    return /*#__PURE__*/_react.default.createElement(EnhancedComponent, (0, _extends2.default)({}, props, {
      activeScreen: activeScreen,
      activeScreenQueries: activeScreenQueries,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 7
      }
    }));
  });
};
var WithScreenQueriesType = exports.WithScreenQueriesType = (cov_2r3fhnpjvg().s[10]++, _propTypes.default.shape({
  xs: _propTypes.default.bool,
  sm: _propTypes.default.bool,
  md: _propTypes.default.bool,
  lg: _propTypes.default.bool,
  xl: _propTypes.default.bool
}));
var _default = exports.default = withScreenQueries;